export const ORG_NAME_MAX_CHARACTER_LENGTH = 50
export const ORG_NAME_MIN_CHARACTER_LENGTH = 4

export const ORG_SLUG_MAX_CHARACTER_LENGTH = 50
export const ORG_SLUG_MIN_CHARACTER_LENGTH = 4
